import React from "react";
import { Server as ServerIcon, Users, Map, Hash } from "lucide-react";
import useFetch from "@/lib/useFetch";
import { PageHeader, Footer } from "@/components/common/Page";
import Loader from "@/components/common/Loader";
import StatusBadge from "@/components/common/StatusBadge";
import Countdown from "@/components/common/Countdown";

export default function Servers() {
    const { data: servers } = useFetch("/servers");
    const { data: communities } = useFetch("/communities");
    if (!servers || !communities) return <Loader />;
    const nameFor = (k) => communities.find((c) => c.key === k)?.name || k;

    return (
        <div data-testid="player-servers">
            <PageHeader title="Servers" subtitle="Live status across every Outpost Rust server." />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {servers.map((s) => (
                    <div key={s.id} data-testid={`server-${s.id}`} className="tactical-card rounded-lg p-5">
                        <div className="flex items-start justify-between">
                            <div>
                                <div className="label-mono text-muted-foreground">{nameFor(s.community_key)}</div>
                                <h3 className="font-heading text-xl font-bold uppercase text-foreground flex items-center gap-2">
                                    <ServerIcon size={16} className="text-hazard" /> {s.name}
                                </h3>
                            </div>
                            <StatusBadge status={s.status} testId={`server-status-${s.id}`} />
                        </div>
                        <div className="grid grid-cols-2 gap-3 mt-4">
                            <Info icon={Users} label="Players" value={`${s.current_players}/${s.max_players}`} />
                            <Info icon={Map} label="Map Size" value={s.map_size} />
                            <Info icon={Hash} label="Seed" value={s.map_seed} />
                            <Info icon={ServerIcon} label="Region" value={s.region} />
                        </div>
                        <div className="mt-4 rounded-md border border-border bg-background/40 p-3">
                            <Countdown target={s.save_wipe} label="Next Save Wipe" />
                        </div>
                    </div>
                ))}
            </div>
            <Footer />
        </div>
    );
}

function Info({ icon: Icon, label, value }) {
    return (
        <div className="flex items-center gap-2">
            <Icon size={14} className="text-muted-foreground" />
            <div>
                <div className="label-mono text-muted-foreground">{label}</div>
                <div className="font-heading font-bold text-foreground">{value}</div>
            </div>
        </div>
    );
}
